import axiosInstance from "./AxiosInstance";

export function getHowToTakes(
  pagination,
  pageid,
  search_by = "",
  search_keyword = "",
  sort_by = "",
  sort_order = ""
) {
  return axiosInstance.post("how-to-take/list", {
    pagination,
    pageid,
    search_by,
    search_keyword,
    sort_by,
    sort_order,
  });
}

export function createHowToTake(howToTakeData) {
  return axiosInstance.post("how-to-take/add", howToTakeData);
}

export function updateHowToTake(howToTakeData) {
  return axiosInstance.post("how-to-take/edit", {
    ...howToTakeData,
  });
}

export function deleteHowToTake(howToTakeId) {
  return axiosInstance.post("how-to-take/delete", {
    how_to_take_id: howToTakeId,
  });
}
export function formatHowToTakes(responseData) {
  if (!Array.isArray(responseData)) return [];

  return responseData.map((item) => ({
    id: item.how_to_take_id,
    text: item.how_to_take_text,
    status: item.how_to_take_status,
    created_at: item.created_at,
    updated_at: item.updated_at,
  }));
}
